import SliderView from '@components/ui-components/slider-view/component.js'

export default {
  components: {
    'slider-view-cmp': SliderView,
  },
  data() {
    return {}
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/gallery/component.js